// File: IntegrationControllerFactory.ts
import { BaseIntegrationController } from './BaseIntegrationController';
import { VcenterController } from './vcenter/controller/VcenterController';
import { IntegrationContainerImageScannerController } from './containerImageScanner/controller/IntegrationContainerImageScannerController';

import { SaveIntegrationWebComponent } from '../saveIntegration';
import { IntegrationTypes } from '../integrationsMarketplaceGridInstalled/types';

export class IntegrationControllerFactory {
  static createController(type: number, component: SaveIntegrationWebComponent): BaseIntegrationController {
    switch (type) {
      case IntegrationTypes.Vcenter:
        return new VcenterController(component);
      case IntegrationTypes.ContainerImageScanner:
        return new IntegrationContainerImageScannerController(component);
      default:
        throw new Error(`Unknown integration type: ${type}`);
    }
  }
}
